module.exports = __webpack_public_path__ + "img/console-deploying.832201b1.svg";